import React from "react";
import "../components/styles/experience.css";

function Experience() {
  return (
    <div className="experience">
      <div className="education">
        {" "}
        <h3>
          <u>Education</u>
        </h3>
      </div>
      <div>
        <h4>Full Stack Web Development Certificate</h4>
        <li>
          Full Stack Web Development Certificate, Kenzie Academy, October, 2023.
        </li>
      </div>
      <br />
      <div className="workExp">
        <h3>
          <u>Work Experience</u>
        </h3>

        <h4>Honeywell International, Inc.</h4>
        <p>
          <strong>Location:</strong> Charlotte, North Carolina (Remote)
        </p>
        <p>
          <strong>Position:</strong> Policy Specialist II
        </p>
        <p>
          <strong>Date:</strong> March 2025 - Current Employee
        </p>
        <ul>
          <li>
            Develop and maintain Power BI semantic models and Excel-based data
            structures for global real estate analytics and executive reporting
          </li>
          <li>
            Transform, standardize, and validate financial and operational data
            from multiple systems to support consistent KPI tracking
          </li>
          <li>
            Build and automate dashboards, ROI models, and recurring reports to
            improve data accessibility and decision-making
          </li>
          <li>
            Design and implement a Python-based commute analysis integrated into
            Power BI to support executive evaluation of site accessibility and
            workforce impact
          </li>
          <li>
            Manage rent payment tracking and reporting across leased sites in
            North America and Canada, ensuring accuracy and compliance
          </li>
          <li>
            Document datasets, calculations, and reporting processes and support
            quality assurance testing for internally developed real estate
            software
          </li>
        </ul>

        <h4>Stewart Title Guaranty Company</h4>
        <p>
          <strong>Location:</strong> Charlotte, North Carolina (Remote)
        </p>
        <p>
          <strong>Position:</strong> Policy Specialist II
        </p>
        <p>
          <strong>Date:</strong> November 2018 - March 2025
        </p>
        <p>
          <strong>Position:</strong> Policy Specialist I
        </p>
        <p>
          <strong>Date:</strong> August 2017 - November 2018
        </p>
        <ul>
          <li>
            Built relationships with attorneys to build business across the
            state of North Carolina.
          </li>
          <li>
            Maintained monthly reports to track premium and office income.
          </li>
        </ul>

        <h4>Stott, Hollowell, Palmer, & Windham, LLP</h4>
        <p>
          <strong>Location:</strong> Gastonia, North Carolina
        </p>
        <p>
          <strong>Position:</strong> Legal Assistant
        </p>
        <p>
          <strong>Date:</strong> April 2016 - August 2017
        </p>
        <ul>
          {" "}
          <li>
            Legal Assistant for a Real Estate lawyer handling closing duties.
          </li>
        </ul>

        <h4>Rogers Townsend & Thomas</h4>
        <p>
          <strong>Location:</strong> Columbia, South Carolina
        </p>
        <p>
          <strong>Position:</strong> Real Estate Paralegal
        </p>
        <p>
          <strong>Date:</strong> February 2016 - April 2016
        </p>
        <ul>
          <li>
            Paralegal for multiple real estate lawyers handling closing duties
            and acting as a liaison with the attorneys, clients, and financial
            institutions.
          </li>
        </ul>

        <h4>Lutzel Broadway & Associates</h4>
        <p>
          <strong>Location:</strong> Charlotte, North Carolina
        </p>
        <p>
          <strong>Position:</strong> Real Estate Paralegal
        </p>
        <p>
          <strong>Date:</strong> February 2015 - February 2016
        </p>
        <ul>
          <li>
            Legal Assistant for two real estate lawyers handling closing duties.
          </li>
        </ul>

        <h4>Thomas & Godley, PLLC</h4>
        <p>
          <strong>Location:</strong> Mooresville, North Carolina
        </p>
        <p>
          <strong>Position:</strong> Real Estate Post Closer
        </p>
        <p>
          <strong>Date:</strong> February 2014 - February 2015
        </p>
        <ul>
          <li>
            Managed post-closing processes for three closers, including file
            preparation for disbursement and lender return.
          </li>
        </ul>

        <p>
          <em>Further Real Estate experience starting September 2007.</em>
        </p>

        <h3>
          <u>ADDITIONAL EXPERIENCE</u>
        </h3>

        <h4>Boy Scouts of America</h4>
        <p>
          <strong>Location:</strong> Shelby, North Carolina
        </p>
        <p>
          <strong>Position:</strong> Bear Den Leader
        </p>
        <p>
          <strong>Date:</strong> October 2021 - Present
        </p>
        <ul>
          <li>
            Teaching youth to be outstanding citizens and have fun along the way
            learning.
          </li>
        </ul>

        <h4>YMCA</h4>
        <p>
          <strong>Location:</strong> McAdenville, North Carolina
        </p>
        <p>
          <strong>Position:</strong> Coach, Tee Ball
        </p>
        <p>
          <strong>Date:</strong> Spring 2019
        </p>
        <ul>
          <li>Teaching kids to play tee ball and have good sportsmanship.</li>
        </ul>
      </div>
    </div>
  );
}

export default Experience;
